import React, { useEffect, useState } from "react";
import { Image, message, Button, FloatButton, Popconfirm } from 'antd';
import { DeleteOutlined, RollbackOutlined } from '@ant-design/icons';
import Upload_Img from "./Upload_Img";
import Qrcode from "./Qrcode";

const cancel = (e) => {
  message.info('Cancel');
};

const InEvent = ({ backbtn, eventID, name, pin }) => {
  const [images, setImages] = useState([]);
  const [hoveredImageIndex, setHoveredImageIndex] = useState(null);
  const [url, seturl] = useState('');
  const [updateName, setupdatename] = useState('');
  const [updatePin, setupdatePin] = useState('');
  const [onEdit, setonEdit] = useState(true);
  const [pin1, setpin] = useState('');
  const [name1, setname] = useState('');
  const [localRefresh, setLocalRefresh] = useState(0); // 👈 Local refresh state

  const d_ref = () => {
    setLocalRefresh((prev) => prev + 1); // 👈 Refresh on upload
  };

  useEffect(() => {
    seturl(`http://localhost:3000/collect/${eventID}`);

    const fetchImages = async () => {
      try {
        const result = await fetch('http://localhost:5000/in-event', {
          method: "POST",
          body: JSON.stringify({ _id: eventID }),
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await result.json();
        if (Array.isArray(data)) {
          setImages(data);
        } else {
          message.error("Images not found!");
          setImages([]);
        }
      } catch (error) {
        message.error("Error fetching images");
        setImages([]);
      }
    };

    fetchImages();
  }, [eventID, localRefresh]); // 👈 Listen to local refresh

  const confirm = async () => {
    try {
      const result = await fetch('http://localhost:5000/delete-event', {
        method: "DELETE",
        body: JSON.stringify({ _id: eventID }),
        headers: { "Content-Type": "application/json" }
      });

      const data = await result.json();
      if (result.ok) {
        message.success(`Event ${data.event_name} is Deleted!`);
        backbtn();
      } else {
        message.error(data.message);
      }
    } catch (error) {
      message.error("Delete failed");
    }
  };

  const handleDelete = async (name, _id) => {
    try {
      const result = await fetch('http://localhost:5000/delete-image', {
        method: "DELETE",
        body: JSON.stringify({ name, _id }),
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await result.json();
      if (data.success) {
        message.success("Image deleted successfully!");
        setImages(images.filter((image) => image.name !== name));
      } else {
        message.error(data.message);
      }
    } catch (error) {
      message.error("Failed to delete image");
    }
  };

  return (
    <div className="">
      {/* Delete Event Button */}
      <Popconfirm
        title="Delete the Event"
        description="Are you sure to delete this Event?"
        onConfirm={confirm}
        onCancel={cancel}
        okText="Yes"
        cancelText="No"
      >
        <FloatButton
          shape="circle"
          type="primary"
          style={{ insetInlineEnd: 24 }}
          icon={<DeleteOutlined />}
        />
      </Popconfirm>

      {/* Back Button */}
      <FloatButton
        shape="circle"
        type="primary"
        style={{ insetInlineEnd: 94 }}
        icon={<RollbackOutlined />}
        onClick={backbtn}
      />

      {/* Event Details */}
      <div>
        <h4 className="p-2">Event: {name1 || name}</h4>
        <p className="pt-4">
          Share this link with guest: <a href={url}>{url}</a>
        </p>
        <Qrcode url={url} />
      </div>

      {/* Upload Section */}
      <Upload_Img event_id={eventID} d_ref={d_ref} inevent={true} />

      {/* Image Display */}
      <div className="row p-4 content-justify-center">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          {images.length > 0 ? (
            images.map((image, index) => (
              <div
                key={index}
                style={{ position: "relative" }}
                onMouseEnter={() => setHoveredImageIndex(index)}
                onMouseLeave={() => setHoveredImageIndex(null)}
              >
                <Image
                  width={180}
                  src={`http://localhost:5000/uploads/${image.name}`}
                  alt={`image ${index}`}
                  style={{ display: "block" }}
                />
                {hoveredImageIndex === index && (
                  <Button
                    type="primary"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(image.name, image._id)}
                    style={{
                      position: "absolute",
                      top: "10%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                      opacity: 0.8,
                    }}
                  />
                )}
              </div>
            ))
          ) : (
            <p>No images found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InEvent;
